import { render, staticRenderFns } from "./ChoiceType.vue?vue&type=template&id=33fa9f16&scoped=true"
import script from "./ChoiceType.vue?vue&type=script&lang=js"
export * from "./ChoiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa9f16",
  null
  
)

export default component.exports